import { useNavigate } from "react-router-dom";

import {
  Button, Container,
} from "react-bootstrap";

/* En tu componente principal (App.js) */
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import HeaderComponent from "../modulos/HeaderComponent";
import FooterComponent from "../modulos/FooterComponent";
import { BsForwardFill } from "react-icons/bs";

const Index = () => {
  // eslint-disable-next-line
  const navigate = useNavigate();
  document.title = "SIDEC | Bienvenido";


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        //backgroundImage:"url(https://www.veracruz.gob.mx/proteccioncivil/wp-content/uploads/sites/5/2024/12/459029599_938750401627993_9216811163148847696_n.jpg)",
        backgroundImage: "url(/background2.jpeg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat"
      }}
    >
      <HeaderComponent />
      <Container style={{ flex: 1 }}>
        <div

          className="container"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "10px",
            padding: "20px",
            marginTop: "20px",
            marginBottom: "20px",
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)"
          }}
        >
          <h3 className="text-center text-contrast" style={{ color: "black" }}>
            {" "}
            BUZÓN DE QUEJAS Y DENUNCIAS CIUDADANA
          </h3>

          <br />

          <p className="justifyalign">
            La Secretaría de Protección Civil es la responsable del tratamiento de los datos
            personales que nos proporcione.  
            <b> Los datos personales que recabamos de usted, los utilizaremos para la siguiente
            finalidad: </b> 
             Registrar en la base de datos a quien presenta la queja, dar atención y contactar en
            caso de ampliación o aclaración de la queja, identificar el Municipio o Localidad de
            quien presenta la queja y generar una estadística interna incluyendo la identidad de
            género.
            Así mismo se comunica que no se efectuarán tratamientos adicionales.
            Para mayor información acerca del tratamiento y de los derechos que puede hacer
            valer, usted puede acceder al aviso de privacidad integral a través de la dirección
            electrónica:
          </p>

          <p className="centeralign goldtext">
            <a
              href="https://repositorio.veracruz.gob.mx/proteccioncivil/wp-content/uploads/sites/15/2025/09/AVISO_18-BUZON-Y-REGISTRO-ELECTRONICO-DE-QUEJAS-CIUDADANAS-ANTE-LA-PRESENCIA-O-DETECCION-DE-RIESGOS-EN-EMPRESAS.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              Aviso de Privacidad
            </a>
          </p>

          {/* <p className="centeralign blackitalic">
            “Este programa es público, ajeno a cualquier partido político. Queda
            prohibido el uso para fines distintos a los establecidos en el
            programa”
          </p> */}

          <div className="d-flex justify-content-center">
            <Button
              href="/registro"
              /* style={{
                border: "none",
                padding: 0,
                cursor: "pointer",
                width: "100%",
                maxWidth: "424px",
                maxHeight:"100px"
              }} */
              className="btn btn-dark"
            >
              {/* <img
                src="/login.png"
                title="Ingresar"
                alt="Ingresar"
                style={{
                  display: "block",
                  width: "100%",
                  maxWidth: "424px",
                  height: "auto"
                }}
              /> */}
              <BsForwardFill /> Ingresar
            </Button>
          </div>

          <br />

        </div>
      </Container>
      <FooterComponent />
    </div>
  );
};

export default Index;
